<mat-card appearance="raised" [ngClass.gt-xs]="'card md'" class="announcement-card" [ngClass]="announcement?.type" [ngSwitch]="announcement?.type">
  <mat-card-content>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxFlex="20" class="icons-column">
        <div class="icon-container" [ngClass]="announcement?.type">
          <mat-icon *ngSwitchCase="AnnouncementType.Important" class="announcement-icon"
            [ngClass]="announcement?.type">warning</mat-icon>
          <mat-icon *ngSwitchCase="AnnouncementType.Notice" class="announcement-icon"
            [ngClass]="announcement?.type">info_outlined</mat-icon>
          <mat-icon *ngSwitchCase="AnnouncementType.Promotion" class="announcement-icon"
            [ngClass]="announcement?.type">campaign</mat-icon>
        </div>
      </div>
      <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="8px" fxFlex="80">
        <div fxLayout="column" fxLayoutGap="12px" fxFlex>
          <div class="announcement-header">
            <span *ngSwitchCase="AnnouncementType.Important" class="announcement-type-label">Important Notice</span>
            <span *ngSwitchCase="AnnouncementType.Notice" class="announcement-type-label">Notice</span>
            <span *ngSwitchCase="AnnouncementType.Promotion" class="announcement-type-label">Promotion</span>
          </div>

          <div class="subject">
            {{ announcement?.subject }}
          </div>
        </div>

        <div fxFlex="80" class="buttons-container">
          <button *ngFor="let button of announcement?.buttons" mat-button
            (click)="handleButtonClick(button.actionType, button.payload)" class="action-button"
            [ngClass]="[announcement?.type, button.actionType]">
            <mat-icon *ngIf="button.actionType === AnnouncementButtonActionType.Copy">content_copy</mat-icon>
            <mat-icon *ngIf="button.actionType === AnnouncementButtonActionType.LinkExternal">link</mat-icon>
            <mat-icon *ngIf="button.actionType === AnnouncementButtonActionType.LinkInternal">link</mat-icon>
            <span>{{ button.label }}</span>
          </button>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
